import { getDisplayType } from 'redux/actions/displayActions'
import { getBrandName } from 'util/brandUtils'
import goerli from '../../images/metamask-sepolia.jpg'
import DisplayUseMainnet from 'components/nft/DisplayUseMainnet'
export default function DisplayUseSepolia() {
    const brandName = getBrandName(getDisplayType())
    if (process.env.REACT_APP_ETH_TEST === 'true') {
        return (
            <div style={{ color: 'black' }}>
                <h4>Be Sure to Connect to the SEPOLIA Network</h4>
                <p>
                    During the {brandName} Beta, all transactions occur on the{' '}

                    Sepolia test network

                    . No actual Ethereum is exchanged, and all test transactions will be
                    ignored once {brandName} goes live on the Ethereum mainnet.
                </p>
                <p>
                    To use Metamask during the beta you must select the Sepolia Test
                    Network from the dropdown at the top of the Metamask extension:
                </p>
                <img
                    src={goerli}
                    align='bottom'
                    width='80vw'
                    alt='Metamask Sepolia'
                />
            </div>
        )
    } else {
        return <DisplayUseMainnet />
    }
}